import { render, staticRenderFns } from "./lclExportRemarkDataGrid.vue?vue&type=template&id=e18c2556&"
import script from "./lclExportRemarkDataGrid.vue?vue&type=script&lang=js&"
export * from "./lclExportRemarkDataGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e18c2556')) {
      api.createRecord('e18c2556', component.options)
    } else {
      api.reload('e18c2556', component.options)
    }
    module.hot.accept("./lclExportRemarkDataGrid.vue?vue&type=template&id=e18c2556&", function () {
      api.rerender('e18c2556', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/PriceLCL/components/lclExportRemarkDataGrid.vue"
export default component.exports